export const cleanRule = (lensPackage: any) =>
  (!lensPackage.color || !lensPackage.color.length) &&
  (!lensPackage.blueLight || !lensPackage.blueLight.length) &&
  (!lensPackage.transition || !lensPackage.transition.length) &&
  (!lensPackage.colorCategory || !lensPackage.colorCategory.length);

export const blueLightRule = (lensPackage: any) =>
  lensPackage.blueLight &&
  lensPackage.blueLight.length &&
  (!lensPackage.transition || !lensPackage.transition.length);

export const transitionRule = (lensPackage: any) =>
  lensPackage.transition && lensPackage.transition.length;

export const sunRule = (lensPackage: any) =>
  lensPackage?.color &&
  lensPackage?.color.length &&
  (!lensPackage.blueLight || !lensPackage.blueLight.length) &&
  (!lensPackage.transition || !lensPackage.transition.length) &&
  lensPackage.colorCategory &&
  lensPackage.colorCategory.length;
